module.exports = __webpack_public_path__ + "img/block.0a852ddb.svg";